import { Events } from "@Context/common/general/context";
import { useEffect } from "react";

const FallbackNavigate = ({ path = "/" }: { path: string }) => {
  useEffect(() => {
    Events.app.navigateExclusive.emit({ path });
  }, []);
  return <></>;
};
export default FallbackNavigate;
